import React, { Component } from 'react';
import NonOpImage from "../../assets/Surg image 2.png";
import "./JointNoi4.css";
import Button from "@material-ui/core/Button";

class JointNoi4 extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <div id="RCPE-Welcome-main-container">
                <div  id="all-content-wrapper">

                    <div id="RCPE-Welcome-box-1">
                        <div id="JointNoi3-inner-box-1">

                            {/* Dic 1 */}
                            <div id="RCPNOI-container-1">
                                <h2 id="RCPNOI-heading"> {`${this.props.Joint_Name} Non-Operative Interventions`} </h2>

                                <div id="RCPNOI-form-box-1">
                                    <form id="RCPNOI-form">

                                        <ul className="RCPNOI-unstyled RCPNOIcentered">
                                            <li>
                                                <input
                                                    className="RCPNOI-styled-checkbox"
                                                    id="SmokingCessation"
                                                    type="checkbox"
                                                />
                                                <label htmlFor="SmokingCessation" className="RCPNOI-form-field">
                                                    Smoking cessation
                                                </label>
                                            </li>

                                            <li>
                                                <input
                                                    className="RCPNOI-styled-checkbox"
                                                    id="WeightLoss"
                                                    type="checkbox"
                                                />
                                                <label htmlFor="WeightLoss" className="RCPNOI-form-field">
                                                    Weight Loss
                                            </label>
                                            </li>

                                            <li>
                                                <input
                                                    className="RCPNOI-styled-checkbox"
                                                    id="NutritionalSupport"
                                                    type="checkbox"
                                                />
                                                <label htmlFor={"NutritionalSupport"} className="RCPNOI-form-field">
                                                    Nutritional support
                                            </label>
                                            </li>

                                            <li>
                                                <input
                                                    className="RCPNOI-styled-checkbox"
                                                    id="HomeExercise"
                                                    type="checkbox"
                                                />
                                                <label htmlFor={"HomeExercise"} className="RCPNOI-form-field">
                                                    Home Exercise
                                                </label>
                                            </li>

                                            <li>
                                                <input
                                                    className="RCPNOI-styled-checkbox"
                                                    id="PhysicalTherapy"
                                                    type="checkbox"
                                                />
                                                <label htmlFor={"PhysicalTherapy"} className="RCPNOI-form-field">
                                                    Physical therapy
                                            </label>
                                            </li>
                                            <li>
                                                <input
                                                    className="RCPNOI-styled-checkbox"
                                                    id="PainManagement"
                                                    type="checkbox"
                                                />
                                                <label htmlFor={"PainManagement"} className="RCPNOI-form-field">
                                                    Pain management
                                            </label>
                                            </li>
                                            <li>
                                                <input
                                                    className="RCPNOI-styled-checkbox"
                                                    id="ComplementaryAlternativePainTreatments"
                                                    type="checkbox"
                                                />
                                                <label htmlFor={"ComplementaryAlternativePainTreatments"} className="RCPNOI-form-field">
                                                    Complementary alternative pain treatments
                                            </label>
                                            </li>
                                            <li>
                                                <input
                                                    className="RCPNOI-styled-checkbox"
                                                    id="AnxietyReduction"
                                                    type="checkbox"
                                                />
                                                <label htmlFor={"AnxietyReduction"} className="RCPNOI-form-field">
                                                    Anxiety reduction
                                            </label>
                                            </li>

                                        </ul>
                                    </form>

                                    <img alt="App" src={NonOpImage} id="JN4-Image" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="RCPE-Welcome-box-2">
                        <div id="RCPE-Welcome-footer-div1">
                            <Button
                                id="RCPE-Welcome-btn-1"
                                variant="contained"
                                onClick={this.props.handleBackClick}
                            >
                                {" "} Back {" "}
                            </Button>
                        </div>

                        <div id="RCPE-Welcome-footer-div3">
                            <Button
                                id="RCPE-Welcome-btn-3"
                                variant="contained"
                                onClick={this.props.handleNextClick}
                            >
                                {" "} Next {" "}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default JointNoi4;